import Vue from 'vue'
import Router from 'vue-router'
import Welcome from './views/Welcome.vue'

Vue.use(Router)

export default new Router({
  	routes: [
		{ path: '/', name: 'home', component: Welcome },

		{ name: 'mecfs', path: '/mecfs', component: () => import(/* webpackChunkName: "Top" */ './views/understanding/Top.vue') },
		{ name: 'causes', path: '/mecfs/causes', component: () => import(/* webpackChunkName: "causes" */ './views/understanding/Causes.vue') },
		{ name: 'symptoms', path: '/mecfs/symptoms', component: () => import(/* webpackChunkName: "symptoms" */ './views/understanding/Symptoms.vue') },
		{ name: 'diagnosis', path: '/mecfs/diagnosis', component: () => import(/* webpackChunkName: "diagnosis" */ './views/understanding/Diagnosis.vue') },
		{ name: 'treatment', path: '/mecfs/treatment', component: () => import(/* webpackChunkName: "treatment" */ './views/understanding/Treatment.vue') },
		{ name: 'management', path: '/mecfs/management', component: () => import(/* webpackChunkName: "management" */ './views/understanding/Management.vue') },

		{ name: 'about', path: '/about', component: () => import(/* webpackChunkName: "about" */ './views/Group.vue') },
		{ name: 'group', path: '/about/group', component: () => import(/* webpackChunkName: "about" */ './views/Group.vue') },
		{ name: 'services', path: '/about/services', component: () => import(/* webpackChunkName: "services" */ './views/Services.vue') },
		{ name: 'meetings', path: '/about/meetings', component: () => import(/* webpackChunkName: "meetings" */ './views/Meeting.vue') },
		{ name: 'membership', path: '/about/membership', component: () => import(/* webpackChunkName: "membership" */ './views/Membership.vue') },
		{ name: 'donate', path: '/about/donate', component: () => import(/* webpackChunkName: "donate" */ './views/Donate.vue') },

		{ name: 'resources', path: '/resources', component: () => import(/* webpackChunkName: "resources" */ './views/Resources.vue') },
		{ name: 'contact', path: '/contact', component: Welcome }
	],
	scrollBehavior (to, from, savedPosition) {
		if (to.path.includes("/mecfs/")) {
			return null;
		}
		return { x: 0, y: 0 };
	}
})
